/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CountryModelSearchResultModel } from '../../models/country-model-search-result-model';
import { SearchRequestModel } from '../../models/search-request-model';

export interface CountrySearchCountryPost$Params {
      body?: SearchRequestModel
}

export function countrySearchCountryPost(http: HttpClient, rootUrl: string, params?: CountrySearchCountryPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<CountryModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, countrySearchCountryPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<CountryModelSearchResultModel>;
    })
  );
}

countrySearchCountryPost.PATH = '/Country/SearchCountry';
